<ng-container *ngIf="config?.theme && config?.theme === 1">
  <div class="row" style="background-color: #f3f2f7">
    <div class="col-sm-12 col-md-4 col-xl-4 contacto d-flex align-items-center">
      Inmoapp &copy; {{ year }}
      <span class="linea">&nbsp;Todos los derechos reservados</span>
    </div>
    <div class="col-sm-12 col-md-4 col-xl-4 axio d-flex align-items-center">
      <!-- Licencias -->
      <div *ngIf="licenses.length > 0" class="row">
        <div *ngFor="let license of licenses" class="col-12">
          <img
            *ngIf="license.license.status"
            src="../../../../../assets/icon/verified.png"
            alt="verified"
            height="20px"
            title="Verificado"
          />
          <span>
            &nbsp;<strong [style]="'color:' + config?.primaryColor + ';'">Licencia </strong>&nbsp;&nbsp;
            {{ license.license.name }}
            &nbsp;<strong [style]="'color:' + config?.primaryColor + ';'">Matricula </strong>&nbsp;&nbsp;
            {{ license.code }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-4 col-xl-4 avisos d-flex align-items-center justify-content-end">
      <span class="mr-1"
        >&nbsp;<strong [style]="'color:' + config?.primaryColor + ';'">Contáctenos </strong>&nbsp;&nbsp;
        {{ config.phone1 }} &nbsp;&nbsp; {{ config.emailRealEstate }}</span
      >
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(1)"
        *ngIf="config.instagramUrl"
      >
        <img src="../../../../../assets/icon/instagram.png" alt="" height="20px" />
      </button>
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(2)"
        *ngIf="config.tikTokUrl"
      >
        <img src="../../../../../assets/icon/tik-tok.png" alt="" height="20px" />
      </button>
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(3)"
        *ngIf="config?.fbUrl"
      >
        <img src="../../../../../assets/icon/facebook.png" alt="" height="20px" />
      </button>
    </div>

    <div class="col-10 col-md-0 mt-2 mb-1 offset-1 justify-content-center">
      <div class="row">
        <div class="col-12 col-md-12 form-group">
          <h5 class="colBlanco" for="fullName">Nombre <small class="red">*</small></h5>
          <input
            placeholder="Tu nombre completo aquí"
            type="text"
            class="form-control round"
            required
            [(ngModel)]="informacion.nombre"
            [ngClass]="fullName.invalid && (fullName.dirty || fullName.touched) ? 'is-invalid' : ''"
            name="fullName"
            id="fullName"
            #fullName="ngModel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <h5 class="colBlanco" for="email">Correo <small class="red">*</small></h5>
          <input
            placeholder="correo@correo.com"
            type="text"
            class="form-control round"
            required
            [(ngModel)]="informacion.correo"
            [ngClass]="email.invalid && (email.dirty || email.touched) ? 'is-invalid' : ''"
            name="email"
            id="email"
            #email="ngModel"
          />
        </div>
        <div class="col-12 col-md-6 form-group">
          <h5 class="colBlanco" for="phone">Teléfono <small class="red">*</small></h5>
          <input
            placeholder="000-000-0000"
            type="text"
            minlength="10"
            maxlength="10"
            class="form-control round"
            required
            [(ngModel)]="informacion.telefono"
            [ngClass]="phone.invalid && (phone.dirty || phone.touched) ? 'is-invalid' : ''"
            name="phone"
            id="phone"
            #phone="ngModel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 form-group">
          <h5 class="colBlanco" for="message">¡Déjanos un mensaje! <small class="red">*</small></h5>
          <textarea
            class="form-control round"
            placeholder=""
            rows="3"
            [(ngModel)]="informacion.mensaje"
            required
            [ngClass]="message.invalid && (message.dirty || message.touched) ? 'is-invalid' : ''"
            name="message"
            id="message"
            maxlength="2000"
            #message="ngModel"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 form-group ml-auto float-right">
          <button
            type="button"
            class="btn btn-primary"
            rippleEffect
            [style]="
              'border-color:' +
              config?.primaryColor +
              ' !important;background-color:' +
              config?.primaryColor +
              ' !important;color:' +
              config.secondaryColor +
              ' !important;'
            "
            (click)="contactoRealEstate()"
          >
            Enviar información
          </button>
        </div>
      </div>
    </div>

    <div class="offset-9 offset-md-9"></div>
    <div class="col-12 col-md-2 mt-2 mb-1 d-flex justify-content-center" style="outline: solid red 1p">
      <label style="color: white; cursor: pointer" (click)="privacyPolicy()">POLÍTICA DE PRIVACIDAD</label>
    </div>
    <div class="col-12 col-md-1 mt-2 mb-1 d-fle justify-content-cente" style="outline: solid red 1p">
      <label style="color: white; cursor: pointer" (click)="nom247()">NOM-247</label>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="config?.theme && config?.theme === 2">
  <div
    class="row"
    [style]="
      'background-color:' +
      config?.primaryColor +
      '50; height: auto; text-align: center; margin: auto; font-size: 20px;'
    "
  >
    <div class="col-sm-12 mt-1">
      Inmoapp &copy; {{ year }}
      <span class="linea">&nbsp;Todos los derechos reservados</span>
    </div>

    <div class="col-12 col-md-12 mt-0 mt-md-0">
      <span class="mr-1"
        >&nbsp;<strong [style]="'color:' + config?.primaryColor + ';'">Contáctenos </strong>&nbsp;&nbsp;
        {{ config.phone1 }} &nbsp;&nbsp; {{ config.emailRealEstate }}</span
      >
    </div>

    <!-- Licencias -->
    <div class="col-12 col-md-12 mt-0 mt-md-0">
      <div *ngIf="licenses.length > 0" class="row">
        <div class="col-12">
          <h3 class="text-center mt-2">
            <strong> Licencias </strong>
          </h3>
        </div>
        <div *ngFor="let license of licenses" class="col-12">
          <img
            *ngIf="license.license.status"
            src="../../../../../assets/icon/verified.png"
            alt="verified"
            height="20px"
            title="Verificado"
          />
          <span>
            &nbsp;<strong [style]="'color:' + config?.primaryColor + ';'">Licencia </strong>&nbsp;&nbsp;
            {{ license.license.name }}
            &nbsp;<strong [style]="'color:' + config?.primaryColor + ';'">Matricula </strong>&nbsp;&nbsp;
            {{ license.code }}
          </span>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-12 mt-3 mt-md-0">
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(1)"
        *ngIf="config.instagramUrl"
      >
        <img src="../../../../../assets/icon/instagram.png" alt="" height="20px" />
      </button>
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(2)"
        *ngIf="config.tikTokUrl"
      >
        <img src="../../../../../assets/icon/tik-tok.png" alt="" height="20px" />
      </button>
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(3)"
        *ngIf="config?.fbUrl"
      >
        <img src="../../../../../assets/icon/facebook.png" alt="" height="20px" />
      </button>
    </div>

    <div class="col-10 col-md-0 mt-2 mb-1 offset-1 justify-content-center">
      <div class="row">
        <div class="col-12 col-md-12 form-group">
          <h5 class="colBlanco" for="fullName">Nombre <small class="red">*</small></h5>
          <input
            placeholder="Tu nombre completo aquí"
            type="text"
            class="form-control round"
            required
            [(ngModel)]="informacion.nombre"
            [ngClass]="fullName.invalid && (fullName.dirty || fullName.touched) ? 'is-invalid' : ''"
            name="fullName"
            id="fullName"
            #fullName="ngModel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <h5 class="colBlanco" for="email">Correo <small class="red">*</small></h5>
          <input
            placeholder="correo@correo.com"
            type="text"
            class="form-control round"
            required
            [(ngModel)]="informacion.correo"
            [ngClass]="email.invalid && (email.dirty || email.touched) ? 'is-invalid' : ''"
            name="email"
            id="email"
            #email="ngModel"
          />
        </div>
        <div class="col-12 col-md-6 form-group">
          <h5 class="colBlanco" for="phone">Teléfono <small class="red">*</small></h5>
          <input
            placeholder="000-000-0000"
            type="text"
            minlength="10"
            maxlength="10"
            class="form-control round"
            required
            [(ngModel)]="informacion.telefono"
            [ngClass]="phone.invalid && (phone.dirty || phone.touched) ? 'is-invalid' : ''"
            name="phone"
            id="phone"
            #phone="ngModel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 form-group">
          <h5 class="colBlanco" for="message">¡Déjanos un mensaje! <small class="red">*</small></h5>
          <textarea
            class="form-control round"
            placeholder=""
            rows="3"
            [(ngModel)]="informacion.mensaje"
            required
            [ngClass]="message.invalid && (message.dirty || message.touched) ? 'is-invalid' : ''"
            name="message"
            id="message"
            maxlength="2000"
            #message="ngModel"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 form-group ml-auto float-right">
          <button
            type="button"
            class="btn btn-primary"
            rippleEffect
            [style]="
              'border-color:' +
              config?.primaryColor +
              ' !important;background-color:' +
              config?.primaryColor +
              ' !important;color:' +
              config.secondaryColor +
              ' !important;'
            "
            (click)="contactoRealEstate()"
          >
            Enviar información
          </button>
        </div>
      </div>
    </div>

    <div class="offset-9 offset-md-9"></div>
    <div class="col-12 col-md-2 mt-2 mb-1 d-flex justify-content-center" style="outline: solid red 1p">
      <label style="color: white; cursor: pointer" (click)="privacyPolicy()">POLÍTICA DE PRIVACIDAD</label>
    </div>
    <div class="col-12 col-md-1 mt-2 mb-1 d-fle justify-content-cente" style="outline: solid red 1p">
      <label style="color: white; cursor: pointer" (click)="nom247()">NOM-247</label>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="config?.theme && config?.theme === 3">
  <div
    class="row"
    style="
      height: fit-content;
      background-image: url('https://imco.org.mx/wp-content/uploads/2020/11/cuartoscuro_706972_digital.jpeg');
      background-size: cover;
      background-position: center;
    "
  >
    <div
      style="
        position: absolute;
        background-color: #2a2929dd;
        height: -webkit-fill-available;
        width: -webkit-fill-available;
      "
    ></div>

    <div class="offset-1 offset-md-3"></div>

    <div class="col-11 col-md-3 mt-2">
      <img class="imagen" [src]="config?.logo" alt="brand-logo" style="height: 100px" />

      <br />
      <h3 class="colBlanco mt-1">{{ config.tradeName }}</h3>
      <br />
      <h5 class="colBlanco">Administración | Compra | Venta | Renta</h5>
      <br />
      <h5 class="colBlanco">* Dirección</h5>
      <br />
      <h5 class="colBlanco">
        {{ config.street }} {{ config.noExt }} Int.{{ config.noInt }}, {{ config.suburb }}, CP:{{ config.postalCode }},
        {{ config.state.name }}, {{ config.province?.name }}
      </h5>
      <br />
      <h5 class="colBlanco">* Teléfonos</h5>
      <br />
      <h5 class="colBlanco" *ngIf="config.phone1">
        {{ config.phone1 | slice : 0 : 3 }}-{{ config.phone1 | slice : 3 : 6 }}-{{ config.phone1 | slice : 6 : 10 }}
      </h5>
      <br />
      <h5 class="colBlanco" *ngIf="config.phone2">
        {{ config.phone2 | slice : 0 : 3 }}-{{ config.phone2 | slice : 3 : 6 }}-{{ config.phone2 | slice : 6 : 10 }}
      </h5>
      <br />
      <h5 class="colBlanco" *ngIf="config.phone3">
        {{ config.phone3 | slice : 0 : 3 }}-{{ config.phone3 | slice : 3 : 6 }}-{{ config.phone3 | slice : 6 : 10 }}
      </h5>
      <br />
      <!-- Licencias -->
      <div *ngIf="licenses.length > 0" class="row colBlanco">
        <div class="col-12">
          <h3 class="mt-2 colBlanco">
            <strong> Licencias </strong>
          </h3>
        </div>
        <div *ngFor="let license of licenses" class="col-12">
          <img
            *ngIf="license.license.status"
            src="../../../../../assets/icon/verified.png"
            alt="verified"
            height="20px"
            title="Verificado"
          />
          <span>
            &nbsp;<strong class="colBlanco">Licencia </strong>&nbsp;&nbsp;
            {{ license.license.name }}
            &nbsp;<strong class="colBlanco">Matricula </strong>&nbsp;&nbsp;
            {{ license.code }}
          </span>
        </div>
      </div>
      <br />
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(1)"
        *ngIf="config.instagramUrl"
      >
        <img src="../../../../../assets/icon/instagram.png" alt="" height="20px" />
      </button>
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(2)"
        *ngIf="config.tikTokUrl"
      >
        <img src="../../../../../assets/icon/tik-tok.png" alt="" height="20px" />
      </button>
      <button
        type="button"
        class="btn btn-icon btn-icon rounded-circle mr-1"
        rippleEffect
        (click)="redirectSN(3)"
        *ngIf="config?.fbUrl"
      >
        <img src="../../../../../assets/icon/facebook.png" alt="" height="20px" />
      </button>
    </div>

    <div class="col-12 col-md-3 mt-2 mb-1 d-flex justify-content-center">
      <ng-container *ngIf="config?.fbUrl">
        <div id="frameFace"></div>
      </ng-container>
    </div>

    <!-- <div class="col-1"></div> -->
    <div class="col-10 col-md-0 mt-2 mb-1 offset-1 justify-content-center">
      <div class="row">
        <div class="col-12 col-md-12 form-group">
          <h5 class="colBlanco" for="fullName">Nombre <small class="red">*</small></h5>
          <input
            placeholder="Tu nombre completo aquí"
            type="text"
            class="form-control round"
            required
            [(ngModel)]="informacion.nombre"
            [ngClass]="fullName.invalid && (fullName.dirty || fullName.touched) ? 'is-invalid' : ''"
            name="fullName"
            id="fullName"
            #fullName="ngModel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <h5 class="colBlanco" for="email">Correo <small class="red">*</small></h5>
          <input
            placeholder="correo@correo.com"
            type="text"
            class="form-control round"
            required
            [(ngModel)]="informacion.correo"
            [ngClass]="email.invalid && (email.dirty || email.touched) ? 'is-invalid' : ''"
            name="email"
            id="email"
            #email="ngModel"
          />
        </div>
        <div class="col-12 col-md-6 form-group">
          <h5 class="colBlanco" for="phone">Teléfono <small class="red">*</small></h5>
          <input
            placeholder="000-000-0000"
            type="text"
            minlength="10"
            maxlength="10"
            class="form-control round"
            required
            [(ngModel)]="informacion.telefono"
            [ngClass]="phone.invalid && (phone.dirty || phone.touched) ? 'is-invalid' : ''"
            name="phone"
            id="phone"
            #phone="ngModel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 form-group">
          <h5 class="colBlanco" for="message">¡Déjanos un mensaje! <small class="red">*</small></h5>
          <textarea
            class="form-control round"
            placeholder=""
            rows="3"
            [(ngModel)]="informacion.mensaje"
            required
            [ngClass]="message.invalid && (message.dirty || message.touched) ? 'is-invalid' : ''"
            name="message"
            id="message"
            maxlength="2000"
            #message="ngModel"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 form-group ml-auto float-right">
          <button
            type="button"
            class="btn btn-primary"
            rippleEffect
            [style]="
              'border-color:' +
              config?.primaryColor +
              ' !important;background-color:' +
              config?.primaryColor +
              ' !important;color:' +
              config.secondaryColor +
              ' !important;'
            "
            (click)="contactoRealEstate()"
          >
            Enviar información
          </button>
        </div>
      </div>
    </div>

    <div class="offset-9 offset-md-9"></div>
    <div class="col-12 col-md-2 mt-2 mb-1 d-flex justify-content-center" style="outline: solid red 1p">
      <label style="color: white; cursor: pointer" (click)="privacyPolicy()">POLÍTICA DE PRIVACIDAD</label>
    </div>
    <div class="col-12 col-md-1 mt-2 mb-1 d-fle justify-content-cente" style="outline: solid red 1p">
      <label style="color: white; cursor: pointer" (click)="nom247()">NOM-247</label>
    </div>
  </div>
</ng-container>
